import { ISearchResult } from '../models/Search/ISearchResult';

function searchServiceMock() {
  function getSearchResults(searchParam: String): Promise<ISearchResult> {
    const searchResult: ISearchResult = {
      record_count: 10,
      records: {
        page: [
          {
            sections: [],
            title: 'Big Job, Wage Gains Foil Fed’s Inflation Fight',
            domainidentifier: [1, 1],
            type: '',
            tags: [
              'Talent Acquisition',
              'Behavioral Competencies',
              'Critical Evaluation',
              'Labor Market Data',
              'HR Expertise',
            ],
            description:
              "U.S. employers added 263,000 new jobs in November, blowing past economists' expectations for a second consecutive month, according to the latest employment report from the U.S. Bureau of Labor Statistics (BLS).",
            item_date: '2022-12-02T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_431,w_765,x_0,y_26/w_auto:100,w_200,q_auto,f_auto/v1/Talent%20Acquisition/iStock-1372783918_zlnzbp',
            external_id: 'ef7d116ceb00e50ddc8c3c985da141a93e770682',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_255,w_255,x_0,y_0/c_fit,f_auto,q_auto,w_767/v1/Author%20Images/roy-maurer-255px_k2nnqf?databtoa=eyIxeDEiOnsieCI6MCwieSI6MCwieDIiOjI1NSwieTIiOjI1NSwidyI6MjU1LCJoIjoyNTV9fQ%3D%3D',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/talent-acquisition/pages/bls-hr-jobs-unemployment-december-2022.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/talent-acquisition',
            published_at: '2022-12-02T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-12-06T14:38:21Z',
            abstract:
              "U.S. employers added 263,000 new jobs in November, blowing past economists' expectations for a second consecutive month, according to the latest employment report from the U.S. Bureau of Labor Statistics (BLS). The data is the latest evidence that one of the hottest labor markets on record is not su",
            kickerlabel: 'Talent Acquisition',
            author: 'Roy Maurer',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.9838042,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: 'Big Job, Wage Gains Foil Fed’s <em>Inflation</em> Fight',
            },
            id: '638f53dd64441fc972542f93',
          },
          {
            sections: [],
            title: 'Employers Confront Inflation in the UK',
            domainidentifier: [1, 1],
            type: '',
            tags: [
              'HR Expertise',
              'Location',
              'Behavioral Competencies',
              'Global Compensation',
              'Europe',
              'Global and Cultural Effectiveness',
              'Global HR',
            ],
            description:
              'As employers and employees cope with the continuing effects of inflation in the U.K., political instability has made it necessary to craft policies independent of uncertain governmental budgets. ',
            item_date: '2022-11-03T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_719,w_1279,x_0,y_40/w_auto:100,w_200,q_auto,f_auto/v1/Global%20HR/inflation1m_bwd1zw',
            external_id: '955d53e3b82b86866bf29780e6971bfbe85ef557',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_719,w_1279,x_0,y_40/c_fit,f_auto,q_auto,w_767/v1/Global%20HR/inflation1m_bwd1zw?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjQwLCJ4MiI6MTI3OSwieTIiOjc1OSwidyI6MTI3OSwiaCI6NzE5fX0%3D',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/global-hr/pages/uk-employers-confront-inflation.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/global-hr',
            published_at: '2022-11-04T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-11-16T17:55:25Z',
            abstract:
              'As employers and employees cope with the continuing effects of inflation in the U.K., political instability has made it necessary to craft policies independent of uncertain governmental budgets. ',
            kickerlabel: 'Global HR',
            author: 'Katie Nadworny',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.782693,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: 'Employers Confront <em>Inflation</em> in the UK',
              description:
                'As employers and employees cope with the continuing effects of <em>inflation</em> in the U.K., political instability has made it necessary to craft policies independent of uncertain governmental budgets. ',
              abstract:
                'As employers and employees cope with the continuing effects of <em>inflation</em> in the U.K., political instability has made it necessary to craft policies independent of uncertain governmental budgets. ',
              rollup_image:
                'https:&#x2F;&#x2F;shrm-res.cloudinary.com&#x2F;image&#x2F;upload&#x2F;c_crop,h_719,w_1279,x_0,y_40&#x2F;w_auto:100,w_200,q_auto,f_auto&#x2F;v1&#x2F;Global%20HR&#x2F;<em>inflation1m_bwd1zw</em>',
            },
            id: '6375240de7b9d250ae66516b',
          },
          {
            sections: [],
            title: 'Average US Pay Increase Projected to Hit 4.6% in 2023',
            domainidentifier: [1, 1],
            type: '',
            tags: [
              'Compensation Strategy and Planning',
              'Salary Surveys',
              'Compensation',
              'HR Expertise',
            ],
            description:
              'Salary increases in 2023 are projected to outpace 2022 pay raises but to trail inflation, new research shows, as insufficient pay raises drive employee turnover.',
            item_date: '2022-11-29T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_407,w_724,x_0,y_50/w_auto:100,w_200,q_auto,f_auto/v1/Compensation/2023_pay_increase_cjmzrq',
            external_id: 'e777d4ad367c7d1870524be8f2e02015eb05afcb',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_407,w_724,x_0,y_50/c_fit,f_auto,q_auto,w_767/v1/Compensation/2023_pay_increase_cjmzrq?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjUwLCJ4MiI6NzI0LCJ5MiI6NDU3LCJ3Ijo3MjQsImgiOjQwN319',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/compensation/pages/us-pay-increase-forecast-for-2023.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/compensation',
            published_at: '2022-11-29T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-12-02T12:57:57Z',
            abstract:
              "Salary increases in 2023 are projected to outpace 2022 pay raises but to trail inflation, new research shows, and more organizations are hiring candidates higher in the open position's salary range. Still, insufficient pay raises are driving employee turnover.",
            kickerlabel: 'Compensation',
            author: 'Stephen Miller, CEBS',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.655019,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              description:
                'Salary increases in 2023 are projected to outpace 2022 pay raises but to trail <em>inflation</em>, new research shows, as insufficient pay raises drive employee turnover.',
              abstract:
                'Salary increases in 2023 are projected to outpace 2022 pay raises but to trail <em>inflation</em>, new research shows, and more organizations are hiring candidates higher in the open position&#x27;s salary range. Still, insufficient pay raises are driving employee turnover.',
            },
            id: '6389f65564441f9ded6cbd5f',
          },
          {
            sections: [],
            title: 'Managing Rising Health Benefits Costs for 2023',
            domainidentifier: [1, 1],
            type: '',
            tags: ['Health Care Costs', 'Benefits', 'Health Care Benefits', 'HR Expertise'],
            description:
              '​With health care benefits costs expected to return to pre-pandemic levels and to continue outpacing overall inflation, employers can take steps now to curb their benefits expenses.',
            item_date: '2022-12-05T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_705,w_1254,x_0,y_0/w_auto:100,w_200,q_auto,f_auto/v1/Benefits/iStock-1351105760_a7agvv',
            external_id: '4689261cdaf19416ad8c543e412e5ac748d13861',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_705,w_1254,x_0,y_0/c_fit,f_auto,q_auto,w_767/v1/Benefits/iStock-1351105760_a7agvv?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjAsIngyIjoxMjU0LCJ5MiI6NzA1LCJ3IjoxMjU0LCJoIjo3MDV9fQ%3D%3D',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/benefits/pages/managing-rising-health-benefits-costs-for-2023.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/benefits',
            published_at: '2022-12-05T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-12-06T14:38:22Z',
            abstract:
              '​With health care benefits costs expected to return to pre-pandemic levels and to continue outpacing overall inflation, employers can take steps now to curb their benefits expenses.',
            kickerlabel: 'Benefits',
            author: 'Katie Navarra',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.601047,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              description:
                '​With health care benefits costs expected to return to pre-pandemic levels and to continue outpacing overall <em>inflation</em>, employers can take steps now to curb their benefits expenses.',
              abstract:
                '​With health care benefits costs expected to return to pre-pandemic levels and to continue outpacing overall <em>inflation</em>, employers can take steps now to curb their benefits expenses.',
            },
            id: '638f53de64441fcc28543099',
          },
          {
            sections: [],
            title: 'In Its 75th Year, SHRM Charts a Course for HR to Drive Change',
            domainidentifier: [1, 1],
            type: '',
            tags: ['HR Careers', 'Organization and Employee Development', 'HR Expertise'],
            description:
              '​Buckle up, HR professionals. Lessons learned from the COVID-19 pandemic, the Great Resignation, inflation and other challenges in the workplace in the last three years ',
            item_date: '2022-11-21T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_675,w_1200,x_0,y_77/w_auto:100,w_200,q_auto,f_auto/v1/About%20SHRM/1100_zuwiij',
            external_id: '998e09c2e86a8ba33d199bfab7e13834dbd09c2c',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_675,w_1200,x_0,y_77/c_fit,f_auto,q_auto,w_767/v1/About%20SHRM/1100_zuwiij?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjc3LCJ4MiI6MTIwMCwieTIiOjc1MiwidyI6MTIwMCwiaCI6Njc1fX0%3D',
            url: 'https://www.shrm.org/about-shrm/pages/in-its-75th-year-shrm-charts-a-course-for-hr-to-drive-change.aspx',
            kickerurl: 'https://www.shrm.org/about-shrm',
            published_at: '2022-11-21T00:00:00Z',
            memberonly: 'false',
            updated_at: '2022-12-02T13:00:06Z',
            abstract:
              '​Buckle up, HR professionals. Lessons learned from the COVID-19 pandemic, the Great Resignation, inflation and other challenges in the workplace over the last three years ',
            kickerlabel: 'About SHRM',
            author: 'SHRM Online staff',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.4746678,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              description:
                '​Buckle up, HR professionals. Lessons learned from the COVID-19 pandemic, the Great Resignation, <em>inflation</em> and other challenges in the workplace in the last three years ',
              abstract:
                '​Buckle up, HR professionals. Lessons learned from the COVID-19 pandemic, the Great Resignation, <em>inflation</em> and other challenges in the workplace over the last three years ',
            },
            id: '6389f6d6196a6795d1a2979d',
          },
          {
            sections: [],
            title: 'Inflation Rate Dips, Still Outpaces Average Wage Gains',
            domainidentifier: [1, 1],
            type: '',
            tags: ['Compensation Strategy and Planning', 'Compensation', 'HR Expertise'],
            description:
              "The consumer price index rose 7.7% for the 12 months ending in October, 2022 a notable decrease from the 9.1% high notched for the period ending in June 2022 but well-above its long-time average, leaving workers' pay raises still trailing rising costs.",
            item_date: '2022-11-10T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_407,w_724,x_0,y_76/w_auto:100,w_200,q_auto,f_auto/v1/Compensation/grocery_shopper_inflation-again_wc4fph',
            external_id: '7cc714817c36964669d38a184d62ed1fa6993a47',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_407,w_724,x_0,y_76/c_fit,f_auto,q_auto,w_767/v1/Compensation/grocery_shopper_inflation-again_wc4fph?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjc2LCJ4MiI6NzI0LCJ5MiI6NDgzLCJ3Ijo3MjQsImgiOjQwN319',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/compensation/pages/october-2022-cpi-and-real-earnings-reports.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/compensation',
            published_at: '2022-11-30T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-12-02T23:10:34Z',
            abstract:
              "The consumer price index rose 7.7 percent for the 12 months ending in October, 2022 a notable decrease from the 9.1-percent high notched for the period ending in June 2022 but well-above its long-time average, leaving workers' pay raises still trailing rising costs. ",
            kickerlabel: 'Compensation',
            author: 'Stephen Miller, CEBS',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.4294925,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: '<em>Inflation</em> Rate Dips, Still Outpaces Average Wage Gains',
            },
            id: '63753f69196a6731c664f58c',
          },
          {
            sections: [],
            title: 'Inflation Ticks Up, Real Wages Fall in August',
            domainidentifier: [1, 1],
            type: '',
            tags: ['Compensation Strategy and Planning', 'Compensation', 'HR Expertise'],
            description:
              "Inflation in August came in hotter than expected despite falling fuel prices. Resilient inflation shrinks the buying power of workers' pay and means the Fed is likely to continue hiking interest rates, increasing recession concerns.",
            item_date: '2022-09-13T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_408,w_725,x_0,y_66/w_auto:100,w_200,q_auto,f_auto/v1/Compensation/inflation_dollars_disolving_cowyh2',
            external_id: '36742f0117390248e56159b2061e4106475b9d59',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_408,w_725,x_0,y_66/c_fit,f_auto,q_auto,w_767/v1/Compensation/inflation_dollars_disolving_cowyh2?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjY2LCJ4MiI6NzI1LCJ5MiI6NDc0LCJ3Ijo3MjUsImgiOjQwOH19',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/compensation/pages/august-2022-cpi-and-real-earnings-reports.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/compensation',
            published_at: '2022-10-13T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-09-22T11:39:52Z',
            abstract:
              "Inflation in August came in hotter than expected despite falling fuel prices. Resilient inflation shrinks the buying power of workers' pay and means the Fed is likely to continue hiking interest rates, increasing recession concerns.",
            kickerlabel: 'Compensation',
            author: 'Stephen Miller, CEBS',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.4089978,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: '<em>Inflation</em> Ticks Up, Real Wages Fall in August',
              description:
                '<em>Inflation</em> in August came in hotter than expected despite falling fuel prices. Resilient <em>inflation</em> shrinks the buying power of workers&#x27; pay and means the Fed is likely to continue hiking interest rates, increasing recession concerns.',
              abstract:
                '<em>Inflation</em> in August came in hotter than expected despite falling fuel prices. Resilient <em>inflation</em> shrinks the buying power of workers&#x27; pay and means the Fed is likely to continue hiking interest rates, increasing recession concerns.',
              rollup_image:
                'https:&#x2F;&#x2F;shrm-res.cloudinary.com&#x2F;image&#x2F;upload&#x2F;c_crop,h_408,w_725,x_0,y_66&#x2F;w_auto:100,w_200,q_auto,f_auto&#x2F;v1&#x2F;Compensation&#x2F;<em>inflation_dollars_disolving_cowyh2</em>',
            },
            id: '63217cd4196a672591993681',
          },
          {
            sections: [],
            title: 'SHRM Releases New Survey on Inflation',
            domainidentifier: [1, 1],
            type: '',
            tags: 'N/A',
            description:
              'Inflation is a top problem facing the country today, with many Americans showing concerns over the steady increase in prices for food, housing, gasoline, utilities and other goods. ',
            item_date: '2022-07-13T00:00:00Z',
            rollup_image: '',
            external_id: 'ab7835501ef4a0b48037f10c83d594bc3ae1eeb6',
            restrictedidentifier: 0,
            image: 'https://www.shrm.org/PublishingImages/shrm-sharing-logo-square-v6.png.jpg',
            url: 'https://www.shrm.org/about-shrm/press-room/press-releases/pages/shrm-releases-new-survey-on-inflation-.aspx',
            kickerurl: 'https://www.shrm.org/about-shrm/press-room/press-releases',
            published_at: '2022-07-13T00:00:00Z',
            memberonly: 'false',
            updated_at: '2022-07-26T13:23:51Z',
            abstract:
              'Inflation is a top problem facing the country today, with many Americans showing concerns over the steady increase in prices for food, housing, gasoline, utilities and other goods. A new survey from the Society for Human Resource Management (SHRM) Research Institute using the SHRM Voice of Work Rese',
            kickerlabel: 'Press Releases',
            author: '',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.3836458,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: 'SHRM Releases New Survey on <em>Inflation</em>',
              description:
                '<em>Inflation</em> is a top problem facing the country today, with many Americans showing concerns over the steady increase in prices for food, housing, gasoline, utilities and other goods. ',
              abstract:
                '<em>Inflation</em> is a top problem facing the country today, with many Americans showing concerns over the steady increase in prices for food, housing, gasoline, utilities and other goods. A new survey from the Society for Human Resource Management (SHRM) Research Institute using the SHRM Voice of Work Rese',
            },
            id: '62dfeae864441f2077096d7f',
          },
          {
            sections: [],
            title: 'Inflation Affects Retirement Plans in the UK',
            domainidentifier: [1, 1],
            type: '',
            tags: [
              'HR Expertise',
              'Location',
              'Global Benefits',
              'Europe',
              'Global and Cultural Effectiveness',
              'Global HR',
              'Behavioral Competencies',
            ],
            description:
              'With inflation in the U.K. at 10 percent, employers and retirement plan trustees are left grappling with the best way to administer their plans. ',
            item_date: '2022-09-07T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_705,w_1254,x_0,y_0/w_auto:100,w_200,q_auto,f_auto/v1/Global%20HR/London7m_qdl8fx',
            external_id: '189ef6a735eae32e7af9d3bbd5a98de73fd957ff',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_705,w_1254,x_0,y_0/c_fit,f_auto,q_auto,w_767/v1/Global%20HR/London7m_qdl8fx?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjAsIngyIjoxMjU0LCJ5MiI6NzA1LCJ3IjoxMjU0LCJoIjo3MDV9fQ%3D%3D',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/global-hr/pages/uk-retirement-plans-inflation.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/global-hr',
            published_at: '2022-09-08T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-09-13T00:54:16Z',
            abstract:
              'With inflation in the U.K. at 10 percent, employers and retirement plan trustees are left grappling with the best way to administer their plans. ',
            kickerlabel: 'Global HR',
            author: 'Katie Nadworny',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.3655477,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: '<em>Inflation</em> Affects Retirement Plans in the UK',
              description:
                'With <em>inflation</em> in the U.K. at 10 percent, employers and retirement plan trustees are left grappling with the best way to administer their plans. ',
              abstract:
                'With <em>inflation</em> in the U.K. at 10 percent, employers and retirement plan trustees are left grappling with the best way to administer their plans. ',
            },
            id: '631fd4b8e7b9d24b14c1282c',
          },
          {
            sections: [],
            title: 'France Takes Steps to Fight Inflation’s Effects on Workers',
            domainidentifier: [1, 1],
            type: '',
            tags: [
              'HR Expertise',
              'Location',
              'Behavioral Competencies',
              'Global Compensation',
              'Europe',
              'Global and Cultural Effectiveness',
              'Global HR',
            ],
            description:
              'With inflation reaching 5.6 percent in France as of September, the French government has taken steps to alleviate the effects of rising costs on employees and employers in the country. ',
            item_date: '2022-11-07T00:00:00Z',
            rollup_image:
              'https://shrm-res.cloudinary.com/image/upload/c_crop,h_658,w_1171,x_0,y_236/w_auto:100,w_200,q_auto,f_auto/v1/Global%20HR/Paris7m_ivwogb',
            external_id: 'cd85a82b5f36f75a482b9284a4e2063fbade04a9',
            restrictedidentifier: 0,
            image:
              'https://cdn.shrm.org/image/upload/c_crop,h_658,w_1171,x_0,y_236/c_fit,f_auto,q_auto,w_767/v1/Global%20HR/Paris7m_ivwogb?databtoa=eyIxNng5Ijp7IngiOjAsInkiOjIzNiwieDIiOjExNzEsInkyIjo4OTUsInciOjExNzEsImgiOjY1OH19',
            url: 'https://www.shrm.org/resourcesandtools/hr-topics/global-hr/pages/france-takes-steps-to-fight-inflation.aspx',
            kickerurl: 'https://www.shrm.org/ResourcesAndTools/hr-topics/global-hr',
            published_at: '2022-11-08T00:00:00Z',
            memberonly: 'false',
            searchsection: 'workplace news',
            updated_at: '2022-11-16T22:17:18Z',
            abstract:
              'With inflation reaching 5.6 percent in France as of September, the French government has taken steps to alleviate the effects of rising costs on employees and employers in the country. ',
            kickerlabel: 'Global HR',
            author: 'Katie Nadworny',
            popularity: 1,
            info: '',
            _index: '5cc05e90f981596e5837234e',
            _type: '_doc',
            _score: 2.3589156,
            _version: null,
            _explanation: null,
            sort: null,
            highlight: {
              title: 'France Takes Steps to Fight <em>Inflation’s</em> Effects on Workers',
              description:
                'With <em>inflation</em> reaching 5.6 percent in France as of September, the French government has taken steps to alleviate the effects of rising costs on employees and employers in the country. ',
              abstract:
                'With <em>inflation</em> reaching 5.6 percent in France as of September, the French government has taken steps to alleviate the effects of rising costs on employees and employers in the country. ',
            },
            id: '6375616ee7b9d29acf561da8',
          },
        ],
      },
      info: {
        page: {
          query: 'inflatio',
          current_page: 1,
          num_pages: 7,
          per_page: 10,
          total_result_count: 64,
        },
      },
    };
    return new Promise(resolve => {
      resolve(searchResult);
      throw new Error('Mock exception!');
    });
  }
  return { getSearchResults };
}

export default searchServiceMock;
